import {
  CURRENT_NOTIFICATION_DATA,
  CURRENT_NOTIFICATION_INDEX,
  IS_SHOW_ELECTRONIC_CONSENTS_DETAIL,
  IS_SHOW_NOTIFICATIONS_DETAIL,
  LSS_BLOCK_NOTIFICATION_DATA,
  NOTIFICATIONS_COUNT,
  NOTIFICATIONS_SUMMARIES,
  RESET_STORE,
} from "../types";

const initialState = {
  count: 0,
  notificationsSummaries: null,
  currentNotificationData: null,
  open: false,
  openElectronicConsents: false,
  lssBlockNotifications: null,
  currentNotificationIndex: 0,
};

export const notificationsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case NOTIFICATIONS_COUNT:
      return { ...state, count: payload };
    case NOTIFICATIONS_SUMMARIES:
      return { ...state, notificationsSummaries: payload };
    case CURRENT_NOTIFICATION_DATA:
      return { ...state, currentNotificationData: payload };
    case IS_SHOW_NOTIFICATIONS_DETAIL:
      return { ...state, open: payload };
    case IS_SHOW_ELECTRONIC_CONSENTS_DETAIL:
      return { ...state, openElectronicConsents: payload };
    case LSS_BLOCK_NOTIFICATION_DATA:
      return { ...state, lssBlockNotifications: payload };
    case CURRENT_NOTIFICATION_INDEX:
      return {
        ...state,
        currentNotificationIndex: state.currentNotificationIndex + 1,
      };
    case RESET_STORE:
      return initialState;
    default:
      return state;
  }
};
